import Vue from 'vue'
import Router from 'vue-router'

import auth from '@/services/auth.service'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const UserServices = () => import('@/views/UserServices')
const UserAccounts = () => import('@/views/UserAccounts')
const UserAccountsPartner = () => import('@/views/UserAccountsPartner')
const UserProfiles = () => import('@/views/UserProfiles')
const UserRoles = () => import('@/views/UserRoles')
const UserStates = () => import('@/views/UserStates')

// Views - public pages
const Page404 = () => import ('@/views/pages/Page404')
const Redirect = () => import ('@/views/pages/Redirect')

Vue.use(Router)

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'user-services',
          name: 'User Services',
          component: UserServices,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'user-accounts',
          redirect: '/user-accounts/employee',
          name: 'User Accounts',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'employee',
              name: 'Employee User Accounts',
              component: UserAccounts,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: 'partner',
              name: 'Partner User Accounts',
              component: UserAccountsPartner,
              meta: {
                requiresAuth: true
              }
            },
          ]
        },
        {
          path: 'user-profiles',
          name: 'User profiles',
          component: UserProfiles,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'user-roles',
          name: 'User Roles',
          component: UserRoles,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'user-states',
          name: 'User States',
          component: UserStates,
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404,
          meta: {
            requiresAuth: false
          }
        },
        {
          path: 'redirect',
          name: 'Redirect',
          props: (route) => ({ query: route.query.hash }, {query: route.query.user}),
          component: Redirect,
          meta: {
            requiresAuth: false
          }
        }
      ]
    },
    {
      path: '*',
      redirect: '/pages/404'
    }
  ]
})

//navigation guards
router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (auth.checkToken()) {
      next()
    } else {
      auth.redirect()
    }
  } else {
    next()
  }
})

export default router
